import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const stmproductApi = createApi({
  reducerPath: 'stmproductApi',
  baseQuery: btBaseQuery,
  tagTypes: ['STMProduct'],

  endpoints: (builder) => ({
    getSTMProducts: builder.query<st_mproduct[], string>({
      query: (cid) => `stmproduct/${cid}`,
      providesTags: ['STMProduct']
    }),
    getSTMProductById: builder.query<st_mproduct, string>({
      query: (id) => `stmproduct/byid/${id}`,
      providesTags: ['STMProduct']
    }),
    insertSTMProduct: builder.mutation({
      query: (stmproduct) => ({
        url: `/stmproduct/`,
        method: 'POST',
        body: stmproduct
      }),
      invalidatesTags: ['STMProduct']
    }),
    updateSTMProduct: builder.mutation({
      query: (stmproduct) => ({
        url: `/stmproduct/`,
        method: 'PUT',
        body: stmproduct
      }),
      invalidatesTags: ['STMProduct']
    }),
    deleteSTMProduct: builder.mutation({
      query: (stmproduct) => ({
        url: `/stmproduct/${stmproduct.pr_id}`,
        method: 'DELETE',
        body: stmproduct
      }),
      invalidatesTags: ['STMProduct']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSTMProductsQuery,
  useGetSTMProductByIdQuery,
  useInsertSTMProductMutation,
  useUpdateSTMProductMutation,
  useDeleteSTMProductMutation
} = stmproductApi;
